import { EmptyState } from '@gorila-shared-ui/components';
import { StyledHead, StyledHeadCell, StyledTable } from 'baseui/table';
import { useEffect } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { useResetRecoilState } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { ALARMS_COLUMNS, EXTENDED_ALARMS_COLUMNS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';
import { selectedReportRowState } from '../../../storage/reports';
import { HistoricAlarm } from '../../../types/currentState';
import AlarmsReportRow from './AlarmsReportRow';

type Props = Readonly<{
  states?: HistoricAlarm[];
  extended?: boolean;
}>;

function AlarmsReportTable({ states, extended = false }: Props) {
  const { styles } = useStyles();
  const resetSelectedReportRowState = useResetRecoilState(selectedReportRowState);

  useEffect(() => {
    return () => {
      resetSelectedReportRowState();
    };
  }, []);

  if (!states?.length) {
    return <EmptyState title="No cuenta con registro de alarmas." />;
  }

  return (
    <StyledTable>
      <StyledHead $width={extended ? '850px' : undefined}>
        {(extended ? EXTENDED_ALARMS_COLUMNS : ALARMS_COLUMNS).map((column, index) => (
          <StyledHeadCell
            key={index}
            style={{
              flex: column.size,
              maxWidth: column.maxWidth ? `${column.maxWidth}px` : undefined,
              justifyContent: column.centered ? 'center' : undefined,
              ...styles.smallTableCellHeader,
            }}
          >
            {column.title}
          </StyledHeadCell>
        ))}
      </StyledHead>
      <div style={{ flex: 1, minHeight: '250px', width: extended ? '850px' : undefined }}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              height={height}
              itemCount={states.length}
              itemSize={() => SMALL_LIST_ITEM_HEIGHT}
              width={width}
              itemData={{ states, extended }}
            >
              {AlarmsReportRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </StyledTable>
  );
}

export default AlarmsReportTable;
